<template>
    <div class="age-popup">
        <img
            src="https://static.tildacdn.com/tild3833-3530-4364-b332-393038623638/logo_dark_PERK.svg"
            alt="PERK logo"
        />
        <div class="age-buttons">
            <h1>Выберете Меню</h1>
            <router-link to="/breakfast_menu" class="btn-popup">Завтраки</router-link>
            <router-link to="/main_menu" class="btn-popup">Основное меню</router-link>
        </div>
    </div> 
</template>

<style>
.age-buttons {
    display: flex;
    flex-direction: column;
}

.btn-popup {
    color: #fff;
    font-size: 18px;
    font-family: 'Roboto';
    line-height: 1.55;
    font-weight: 300;
    background-color: #41464b;
    border: 0;
    cursor: pointer;
    width: 200px;
    height: 40px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}
</style>